import React from 'react';

interface CardSkeletonProps {
    count: number;
}

const CardSkeleton: React.FC<CardSkeletonProps> = ({ count }) => {
    return (
        <div className="relative z-0 grid grid-cols-1 gap-4 pb-16 md:gap-10 md:mx-8 lg:mx-16 px-4 mt-4 overflow-visible">
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="col-span-1 md:col-span-1 lg:col-span-1">
                    <div className="w-full h-32 bg-gray-400 animate-pulse rounded-lg"></div>
                </div>
            ))}
        </div>
    );
};

export default CardSkeleton;